















import Vue from 'vue'
import LivePatientStatus from '@/components/live-dashboard/LivePatientStatus.vue'
import { LIVE_DASHBOARD_TYPES } from '@/constants/live-dashboard'
import { getPatientName } from '@/utils/patients'
import { DataPoint } from '@/jsonapi/CommonTypes'

export default Vue.extend({
  components: {
    LivePatientStatus,
  },
  props: {
    livePatientWithHistories: {
      type: Object,
      required: true,
    },
  },
  computed: {
    cards(): Array<{ key: LIVE_DASHBOARD_TYPES; data: DataPoint[] }> {
      return [
        { key: LIVE_DASHBOARD_TYPES.PulseRates, data: this.livePatientWithHistories.pulseRates },
        { key: LIVE_DASHBOARD_TYPES.OxygenSaturations, data: this.livePatientWithHistories.oxygenSaturations },
      ]
    },
    patientName(): string {
      return getPatientName({
        firstName: this.livePatientWithHistories.firstName,
        lastName: this.livePatientWithHistories.lastName,
        id: this.livePatientWithHistories.id,
      })
    },
  },
})
